export default __webpack_public_path__ + "static/media/cert-general-staff-a-hkgcsmeaa-sc.7bdeeb19.jpg";